import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ProfileAccountStatus from './ProfileAccountStatus';
import history from '../../../../history';

const AccountStatusProfile = (props) => {
    //<PrivateRoute path={`${process.env.PUBLIC_URL}/management/financial-status-account`}
    const [third, setThird] = useState(null)
    const client = props.location.state?.client;
    useEffect(() => {
        const loadThird = async (id_tercero) => {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id_tercero, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('response', data)
                    if (data.existe) {
                        setThird(data.contenido[0]);
                    } else {
                        setThird(null);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        if (props.location.state?.id_third !== null) {
            loadThird(props.location.state?.id_third);
        }
    }, [])

const goBackBillfoldList = () => {
    history.push({
        pathname: process.env.PUBLIC_URL + '/management/billfold',
      });
}

    return (
        <Fragment>
            <Container className="dashboard">
                {third !== null ?
                    <Row>
                        <Col md={12}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <div style={{ margin: '1em' }}>
                                    <Tooltip
                                        title="Regresar a Cartera"
                                        style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                    >
                                        <IconButton
                                            aria-label="upload picture"
                                            component="span"
                                            className='tooltip-top'
                                            onClick={() => {
                                                //this.warningToGoBackToClinicsHistoryList();
                                                goBackBillfoldList();
                                            }}
                                        >
                                            <ArrowBackIcon style={{ color: '#153365' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <div><h3>Estado de Cuenta Cliente</h3></div>
                                    <div><h3 style={{ color: '#0084CF' }}><b>{'NIT: ' + third.nit + ' ' + third.nombre}</b></h3></div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col md={12}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <div style={{ margin: '1em' }}>
                                    <Tooltip
                                        title="Regresar a Cartera"
                                        style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                    >
                                        <IconButton
                                            aria-label="upload picture"
                                            component="span"
                                            className='tooltip-top'
                                            onClick={() => {
                                                //this.warningToGoBackToClinicsHistoryList();
                                                goBackBillfoldList();
                                            }}
                                        >
                                            <ArrowBackIcon style={{ color: '#153365' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <div> <h3>Estado de Cuenta Cliente </h3></div>
                                    <div> <h3 style={{ color: '#0084CF' }}><b>{client?.tip_documento + ' ' + client?.num_documento + ' ' + client?.nombres + ' ' + client?.apellido1 + ' ' + client?.apellido2}</b></h3></div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                }
                <Row>
                    <ProfileAccountStatus id_historia={props.location.state?.client.id_historia} id_tercero={props.location.state?.id_third} />
                </Row>
            </Container>
        </Fragment>
    )
}

export default AccountStatusProfile